import {Injectable} from '@angular/core';
import {BlobServiceClient} from '@azure/storage-blob';
import * as AWS from 'aws-sdk';
import {environment} from 'src/environments/environment';

// import * as AWS from 'aws-sdk';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {

  imageObject: unknown;

  constructor() {
  }

  async uploadPageScreenShots(element: any, folder = 'page_screenshot') {
    const AWSService = AWS;
    const imageEnvCognito =
      environment.componentImageUploading.CredentialsProvider.CognitoIdentity.Default;
    const imageEnvUtility = environment.componentImageUploading.S3TransferUtility.Default;
    const region = imageEnvUtility.Region;
    const bucketName = imageEnvUtility.Bucket;
    const IdentityPoolId = imageEnvCognito.PoolId;

    // CloudFront distribution domain based on bucket name
    const cloudfrontDomain = bucketName == 'dev-beeos' ? 'https://d2yx15pncgmu63.cloudfront.net' : 'https://d2z9497xp8xb12.cloudfront.net';

    // Configure AWS with Cognito credentials
    AWSService.config.update({
      region: region,
      credentials: new AWSService.CognitoIdentityCredentials({
        IdentityPoolId: IdentityPoolId,
      }),
    });

    // Configure S3 service
    const s3 = new AWSService.S3({
      apiVersion: '2012-07-10',
      params: {
        Bucket: bucketName,
      },
    });

    let imgPromise = new Promise((res, rej) => {
      if (element) {
        const reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onload = () => {
          // Generate a unique key for the file
          let sanitizedFileName = element.name.replace(/\s+/g, '');
          const fileKey =
            `${folder}/` +
            Math.floor(100000 + Math.random() * 900000) +
            'c' +
            new Date().getTime() +
            sanitizedFileName.replace(' ','_');

          // Upload to S3 bucket (which is the origin for CloudFront)
          s3.upload(
            {
              Key: fileKey,
              Bucket: bucketName,
              ContentType: element.type,
              ContentDisposition: 'inline',
              Body: element,
              ACL: 'public-read',
            },
            function (err: any, data: any) {
              if (err) {
                rej(err);
              } else {
                // Modify the response to use CloudFront URL instead of S3 URL
                const cloudfrontResponse = {
                  ...data,
                  // Override the S3 URL with CloudFront URL
                  Location: `${cloudfrontDomain}/${fileKey}`
                };
                res(cloudfrontResponse);
              }
            }
          );
        };
      } else {
        rej(new Error('No file element provided'));
      }
    });

    return imgPromise
      .then((data) => {
        this.imageObject = data;
        return data;
      })
      .catch((err) => {
        
        return err;
      });
  }

  async deleteImages(imageList: any[], folder = 'seo') {
    const AWSService = AWS;
    const imageEnvCognito =
      environment.componentImageUploading.CredentialsProvider.CognitoIdentity.Default;
    const imageEnvUtility = environment.componentImageUploading.S3TransferUtility.Default;
    const region = imageEnvUtility.Region;
    const bucketName = imageEnvUtility.Bucket;
    const IdentityPoolId = imageEnvCognito.PoolId;
    // ? Configures the AWS service and initial authorization
    AWSService.config.update({
      region: region,
      credentials: new AWSService.CognitoIdentityCredentials({
        IdentityPoolId: IdentityPoolId,
      }),
    });
    // ? adds the S3 service, make sure the api version and bucket are correct
    let imgPromise = new Promise((res, rej) => {
      imageList.forEach((img) => {
        let imgname = img.split('/');
        const s3 = new AWSService.S3({
          apiVersion: '2020-01-18',
          params: {Bucket: bucketName},
        });
        let params = {
          Bucket: bucketName,
          Key: `${folder}/${imgname[imgname.length - 1]}`,
        };
        s3.deleteObject(params, (err, result) => {
          if (err) {
            rej('Unable to delete!');
            //  this.ErrorPopsService.open('Image Not Deleted', 'Close', {
            //    duration: 5000,
            //  });
          } else {
            res('Removed Selected Image!');
            //  this.ErrorPopsService.open(`Removed Selected Image!`, 'Close', {
            //    duration: 5000,
            //  });
          }
        });
      });
    });

    return imgPromise
      .then((data: any) => {
        return {data: data, res: true};
      })
      .catch((err) => {
        return {data: err, res: false};
      });
  }

  async uploadFileInAzure(file: File, folderName: string = 'cmis') {
    const sasToken = environment.cmisFileUpload.sasToken.startsWith('?')
      ? environment.cmisFileUpload.sasToken
      : `?${environment.cmisFileUpload.sasToken}`;
    const accountName = environment.cmisFileUpload.accountName;
    const containerName = environment.cmisFileUpload.containerName;

    const blobServiceClient = new BlobServiceClient(`https://${accountName}.blob.core.windows.net${sasToken}`);
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blobName = `${folderName}/${file.name}`;
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);

    await blockBlobClient.uploadData(file, {
      blobHTTPHeaders: {blobContentType: file.type},
    });

    return blockBlobClient;
  }

  async deleteFileInAzure(url: string, folderName: string = 'cmis') {
    const blobServiceClient = new BlobServiceClient(url);
    const containerClient = blobServiceClient.getContainerClient(environment.cmisFileUpload.containerName);

    try {
      const blobClient = containerClient.getBlobClient(folderName);
      await blobClient.delete();
    } catch (error) {
      
    }

  }
}
